import "./PhotogrammetryWorks.module.css";
import Header from "@/reusable_sections/Header";
import ArmenianPhotogrammetryHero from "./sections/ArmenianPhotogrammetryHero";
import PaymentOptions from "./sections/PaymentOptions";
import PhotogrammetryServicesGrid from "./sections/PhotogrammetryServicesGrid";
import TechnicalProcessingLevels from "./sections/TechnicalProcessingLevels";
import Footer from "@/reusable_sections/Footer";
export default function PhotogrammetryWorksPage() {
  return <div>
      <Header />
      <ArmenianPhotogrammetryHero />
      <PaymentOptions />
      <PhotogrammetryServicesGrid />
      <TechnicalProcessingLevels />
      <Footer />
    </div>;
}